import tw from "twin.macro";
import "styled-components/macro";

export const SelectWrapper = ({ children }) => <div tw="min-w-[150px]">{children}</div>;
